import { PermissionsContext } from '@britishcouncil/react-common';
import React from 'react';
import { permissionsStore } from 'store';
import { PermissionLoadingContext } from './useAppPermissions';
import { useNavigationContext } from 'hooks';

export const PermissionsProvider = ({ children }: { children: React.ReactNode }) => {
  const { organisationId, countryId, centreId, locationId } = useNavigationContext();
  const {
    data: permissions = [],
    isFetching,
    isLoading,
  } = permissionsStore.service.useGetPermissionsQuery({
    organisationId,
    countryId,
    centreId,
    locationId,
  });

  return (
    <PermissionsContext.Provider value={{ permissions: permissions }}>
      <PermissionLoadingContext.Provider value={{ isFetching, isLoading }}>
        {children}
      </PermissionLoadingContext.Provider>
    </PermissionsContext.Provider>
  );
};
